import React from "react";

// Molecule: Consent Checkbox = Checkbox atom + label text. The whole label row
// is the click/touch target (>=44px via .smww-checkbox-label).
const ConsentCheckbox = ({ label, name, id, defaultChecked, onChange }) => (
    <label
        className="smww-checkbox-label"
        data-atomic="molecule"
        data-atomic-name="consent-checkbox"
    >
        <input
            type="checkbox"
            id={id}
            name={name}
            defaultChecked={defaultChecked}
            onChange={onChange}
            className="smww-checkbox"
            data-atomic="atom"
            data-atomic-name="checkbox"
        />
        <span className="smww-text smww-text--small" data-atomic="atom" data-atomic-name="body-text">
            {label}
        </span>
    </label>
);

export default ConsentCheckbox;
